import React from 'react';

import { useConfiguration } from '../../../hooks/Configuration';

interface IImageProps {
    imageId: string
}
//img_girl.jpg
function Image({ imageId }: IImageProps) {
    const configuration = useConfiguration();

    return (
        <div className='stx-media-wrapper'>
            <img
                src={`${configuration?.mediaPath}${imageId}`}
                alt="" />
        </div>
    );
}

export default Image;
